import { createSelector } from 'reselect'
import { selectPlans } from './selectPlans'

export const selectHasPlans = createSelector(selectPlans, plans => {
  return plans.length !== 0
})
